import { EBooleanSearch } from '@/helpers/enums'

export function mapQueryParams(...args) {
  return Object.fromEntries(
    args.map(({ propName, queryParam, serializer, deserializer, multiple }) => [
      propName,
      {
        get() {
          const rawValue = this.$route.query[queryParam]

          // prettier-ignore
          return (
            typeof deserializer === 'function'
              ? deserializer(rawValue, this)
              : rawValue
          ) ?? (multiple ? [] : undefined)
        },

        async set(value) {
          this.$emit('before-update')

          // prettier-ignore
          const payload = typeof serializer === 'function'
            ? serializer(value, this)
            : value

          if (payload || payload?.length) {
            await this.$updateQuery(this.$route.query, { [queryParam]: payload })
          } else if (queryParam in this.$route.query) {
            await this.$cleanQuery(this.$route.query, [queryParam])
          }

          this.$emit('updated')
        }
      }
    ])
  )
}

export function basicSerializer(value) {
  return value
    .map((e) => `${e.queryType || EBooleanSearch.EQ}|${encodeURIComponent(e.queryName)}`)
    .join(',')
}

export function basicDeserializer(value) {
  return value?.split(',').map((e) => ({
    queryName: decodeURIComponent(e.split('|')[1]),
    queryType: e.split('|')[0]
  }))
}
